import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const ProgressBarStyle = (theme: Theme) => createStyles({
    root: {
        backgroundColor: styleColors.transparent,
        width: '100%',
        height: '10px',
        borderRadius: '5px',
    },
    determinate: {
        '&:before': {
            content: '" "',
            position: 'absolute',
            zIndex: 0,
            height: '6px',
            width: '100%',
            top: '2px',
            left: 0,
            backgroundColor: styleColors.greyLight3,
            borderRadius: '5px',
        }
    },
    indeterminate: {

    },
    bar: {
        borderRadius: '5px',
    },
    barColorPrimary: {
        backgroundColor: theme.palette.primary.light,
    },
    barColorSecondary: {
        backgroundColor: theme.palette.secondary.light,
    }

});



// WEBPACK FOOTER //
// ./src/components/common/progressBar/progressBar.style.ts